import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { createCheckout } from "@/lib/api";

export const SubscribeButton = ({ label = "Inizia ora — 997€/anno", testid, className = "", small = false }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout();
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Qualcosa è andato storto. Riprova tra un attimo.");
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={testid}
      onClick={handleClick}
      disabled={loading}
      className={`cta-pulse group inline-flex items-center justify-center gap-3 rounded-full bg-purple-600 font-heading font-bold text-white transition-[transform,background-color] duration-300 hover:bg-purple-700 hover:scale-[1.04] active:scale-[0.98] disabled:opacity-70 ${
        small ? "px-6 py-3 text-sm" : "px-8 py-4 text-base sm:px-10 sm:py-5 sm:text-lg"
      } ${className}`}
    >
      {loading ? (
        <>
          <Loader2 className="h-5 w-5 animate-spin" />
          Apro il checkout sicuro...
        </>
      ) : (
        <>
          {label}
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
        </>
      )}
    </button>
  );
};
